import { forwardRef } from "react";

import { cn } from "@/ui/lib";
import {
  CALLOUT_WRAPPER_DEFAULT_PROPS,
  type TCalloutWrapperProps,
} from "./Callout.config";
import {
  getCalloutAssetGridClass,
  getCalloutOrientationGridClass,
} from "./Callout.utils";

export const CalloutWrapper = forwardRef<HTMLDivElement, TCalloutWrapperProps>(
  (
    {
      children,
      className,
      asset,
      orientation,
      "data-component": component = CALLOUT_WRAPPER_DEFAULT_PROPS["data-component"],
      ...props
    },
    ref,
  ) => (
    <div
      {...props}
      ref={ref}
      data-component={component}
      className={cn(
        "w-full rounded-sys-sm px-4 py-3 shadow-sm",
        "grid gap-x-3 gap-y-1",
        getCalloutAssetGridClass(asset),
        getCalloutOrientationGridClass(orientation),
        className,
      )}
    >
      { children }
    </div>
  ),
);

CalloutWrapper.displayName = "CalloutWrapper";
